
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonContent,
  IonFab,
  IonFabButton,
  IonFooter,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonToolbar,
  alertController,
} from '@ionic/vue'
import { 
  defineComponent,
  ref, 
  reactive, 
  computed,
  onMounted,
  onUpdated,
  onBeforeUpdate
} from 'vue'
import { add, createOutline, trashOutline, chevronDownCircleOutline, filterOutline } from 'ionicons/icons'
import { useRouter } from 'vue-router'
import "firebase/firestore";
import AppHeader from '@/components/AppHeader.vue'
import IncomeForm from '@/components/IncomeForm.vue'
import AppFooter from '@/components/AppFooter.vue'
import ReportFilter from '@/components/ReportFilter.vue'
import useFirebaseFirestore from "../hooks/firebase-firestore"

export default defineComponent({
  name: 'IncomesPage',
  components: {
    IonButton,
    IonCard,
    IonCardContent,
    IonContent,
    IonFab,
    IonFabButton,
    IonFooter,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonModal,
    IonPage,
    IonRefresher,
    IonRefresherContent,
    IonToolbar,
    AppHeader,
    AppFooter,
    IncomeForm,
    ReportFilter
  },
  setup() {
    const isAddIncomeOpenRef = ref(false)
    const setAddIncomeOpen = (state: any) => isAddIncomeOpenRef.value = state

    const isFilterOpenRef = ref(false)
    const setFilterOpen = (state: any) => isFilterOpenRef.value = state

    const incomeFormAction = { 
      formType: 'AddIncomeItem',
      type: 'income',
      categoryLists: {},
      filterData: {
        fromDate: '',
        toDate: '',
        category: []
      },
      formDetail: {
        id: null,
        category: null,
        description: null,
        transactionDate: null,
        nominal: 0
      }
    }

    const incomeState = reactive ({
      selectedBookId: null,
    })

    const selectedBookId = async () => {
      // const selectedBook: any = await localStorage.getItem('selectedBook')
      // console.log(JSON.parse(selectedBook).id)
      // reportState.selectedBookId = JSON.parse(selectedBook).id
      const selectedBook: any = await useFirebaseFirestore().selectedBookId
      incomeState.selectedBookId = selectedBook
      return incomeState.selectedBookId
    }
    const collectionType = "income"
    let incomeFormKey = 1

    const sortOptions = {
      by: "createdAt",
      rule: "desc"
    }

    const today = new Date();
    const filterOptions = {
      fromDate: new Date(today.getFullYear(), today.getMonth(), 1),
      toDate: new Date(today.getFullYear(), today.getMonth() + 1, 0),
      category: []
    }

    const categoryLists = async () => {
      const localSelectedBooks: any = await localStorage.getItem('selectedBook')
      const selectedBooks = JSON.parse(localSelectedBooks)
      incomeFormAction.categoryLists = selectedBooks.settings.categories
      // filterOptions.category = selectedBooks.settings.categories.income
      // console.log(incomeFormAction.formDetail.categoryLists)
    }
    
    const incomeData = reactive <Map<string, any>>(new Map<string, any>())

    const displayIncomeData = computed(() => Array.from(incomeData.values()))
    
    const finalBalance = computed (() => {
      const incomeNominal = displayIncomeData.value.map( (item) => item.nominal)
      const totalIncome = incomeNominal.reduce( (accumulator, item) => {
        return accumulator + item;
      }, 0)
      return totalIncome
    })

    const displayDate = (transactionDate: any) => transactionDate.toDate().toDateString()
    const displayNominals = (nominal: number) => new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(nominal)

    const getIncomeData = async () => {
      incomeData.clear()
      const queryIncomeData = await useFirebaseFirestore()
          .getItem(collectionType, sortOptions, filterOptions);
      if (queryIncomeData.status == 1) {
        queryIncomeData.data.forEach( (doc: any) => {
          const itemId = doc.id
          incomeData.set(itemId, {
            ...doc.data(),
            id: itemId,
          })
        })
      }
      // console.log(incomeData)
    }

    const submitIncomeForm = async (event: any) => {
      // console.log(event)
      if (event.action === "AddIncomeItem") {
        const docId = String(new Date().getTime())
        await useFirebaseFirestore()
          .addNewItem(
            collectionType,
            docId,
            {...event.formData}
          )
        // console.log(addItem)
        // incomeData.set(addItem.id, {
        //   ...event.formData,
        //   addItem.id
        // })
        
      } else if (event.action === "ModifyIncomeItem") {
        // incomeData.set(event.formData.id, {
        //   ...event.formData
        // })
        await useFirebaseFirestore()
          .modifyItem(
            collectionType,
            event.formData.id, 
            {
              ...event.formData
            }
          )
      }
      setAddIncomeOpen(false)
      await getIncomeData()
      localStorage.setItem('needUpdateReportList', "1")
      incomeFormKey++
      Object.assign (incomeFormAction, {
        formType: 'AddIncomeItem',
        formDetail: {
          id: null,
          category: null,
          description: null,
          transactionDate: null,
          nominal: 0
        }
      })
      // console.log(displayIncomeData)
    }
    
    const closeIncomeForm = (event: any) => {
      // console.log(event)
      event.action == 'close' ? setAddIncomeOpen(false) : null
      Object.assign (incomeFormAction, {
        formType: 'AddIncomeItem',
        formDetail: {
          id: null,
          category: null,
          description: null,
          transactionDate: null,
          nominal: 0
        }
      })
    }

    const deleteIncomeItem = async (item: any) => {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: 'Confirm!',
          message: 'Delete Item ' + item.description + ' !!!',
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              cssClass: 'secondary',
              handler: () => {
                // console.log('Confirm Cancel:', blah)
              },
            },
            {
              text: 'Okay',
              handler: async () => {
                incomeFormKey++
                incomeData.delete(item.id)
                await useFirebaseFirestore()
                  .deleteItem(
                    collectionType, 
                    item.id
                  )
                localStorage.setItem('needUpdateReportList', "1")
                // await getIncomeData()
                // console.log('Confirm Okay')
              },
            },
          ],
        });
      return alert.present();
    }

    const modifyIncomeItem = (item: any) => {
      // console.log(item)
      Object.assign (incomeFormAction, {
        formType: 'ModifyIncomeItem',
        formDetail: {
          id: item.id,
          category: item.category,
          description: item.description,
          transactionDate: item.transactionDate,
          nominal: item.nominal
        }
      })
      incomeFormKey++
      // console.log('Income Form Key' + incomeFormKey)
      setAddIncomeOpen(true)
    }

    const actionIncomeItem = async (item: any) => {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: 'Confirm!',
          message: 'Modify Item ' + item.description + ' !!!',
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              cssClass: 'secondary',
              handler: () => {
                // console.log('Confirm Cancel:', blah)
              },
            },
            {
              text: 'Delete',
              handler: () => {
                deleteIncomeItem(item)
              },
            },
            {
              text: 'Modify',
              handler: () => {
                modifyIncomeItem(item)
              },
            },
          ],
        });
      return alert.present();
    }

    const checkBookId = async () => {
      // console.log('Last BookID: ' + incomeState.selectedBookId)
      const currentBook: any = await localStorage.getItem('selectedBook')
      const currentBookId = JSON.parse(currentBook).id
      // console.log('current BookID: ' + currentBookId)
      if (currentBookId !== incomeState.selectedBookId) {
        // console.log('Selected Book ID different')
        // console.log('New BookId: ' + incomeState.selectedBookId)
        // console.log('Need Update Income Data')
        incomeState.selectedBookId = currentBookId
        await getIncomeData()
        // return {status: 1, message: 'Need Update'}
      } else {
        // console.log('Selected Book ID same')
        // console.log('No Need Update Data')
        // return {status: 0, message: 'No Need Update'}
      }
    }

    const doRefresh = (event: any) => {
      // console.log('Begin async operation');

      setTimeout(async () => {
        // console.log('Async operation has ended');
        await getIncomeData()
        event.target.complete();
      }, 5000);
    }

    const filterData = async (event: any) => {
      console.log(event.action)
      if (event.action == 'filter') {
        filterOptions.fromDate = event.formData.filterFromDate
        filterOptions.toDate = event.formData.filterToDate
        filterOptions.category = event.formData.filterCategory
        incomeFormAction.filterData.fromDate = event.formData.filterFromDate
        incomeFormAction.filterData.toDate = event.formData.filterToDate
        incomeFormAction.filterData.category = event.formData.filterCategory
        setFilterOpen(false)
        await getIncomeData()
      }
    }

    const closeFilterData = (event: any) => {
      // console.log(event)
      event.action == 'close' ? setFilterOpen(false) : null
    }

    onMounted( async () => {
      await selectedBookId()
      await categoryLists()
      await getIncomeData()
    })

    onBeforeUpdate ( () => {
      // console.log('on Befreupdate')
      setFilterOpen(false)
      setAddIncomeOpen(false)
    })

    onUpdated( async () => {
      // console.log('updated!')
      // const checkBookId = await useGlobalHelpers()
      //       .checkBookId(state.selectedBookId)
      // console.log(checkBookId)
      // if (checkBookId.status == 1) {
      //   await getIncomeData()
      // }
      await categoryLists()
      await checkBookId()
      // await getIncomeData()
    })

    return {
      //function
      ...incomeState,
      router: useRouter(),
      isAddIncomeOpenRef,
      setAddIncomeOpen,
      isFilterOpenRef,
      setFilterOpen,
      incomeFormAction,
      submitIncomeForm,
      closeIncomeForm,
      actionIncomeItem,
      deleteIncomeItem,
      modifyIncomeItem,
      incomeFormKey,
      displayIncomeData,
      finalBalance,
      getIncomeData,
      selectedBookId,
      checkBookId,
      doRefresh,
      filterData,
      closeFilterData,
      
      //properties
      displayDate,
      displayNominals,
      sortOptions,

      //icon
      add,
      createOutline,
      trashOutline,
      chevronDownCircleOutline,
      filterOutline
    }
  }
})
